import { useState } from "react";
import { adminRequest, mutationBody } from "../api";
import { useAdminContext } from "../context";
import { useAdminData } from "../hooks";
import { AsyncPanel, InlineNotice, Section } from "./ui";

type Policy = { minimumLiveBuildNumber: number; revision: number; updateUrl: string };
export function ClientBuildControls() {
  const state = useAdminData<Policy>("/admin/client-policy");
  const { identity, tokens } = useAdminContext();
  return <Section title="App updates" description="Android clients below this build are blocked at startup and on foreground. Publish and verify the replacement APK before raising the minimum. Zero allows all builds that support the check.">
    <AsyncPanel {...state}>{({ data }) => <PolicyForm key={data.revision} policy={data} canEdit={identity.capabilities.includes("admin:updates")} save={async (input) => {
      await adminRequest("/admin/client-policy", tokens, { method: "POST", ...mutationBody(input) }); state.reload();
    }} />}</AsyncPanel>
  </Section>;
}
function PolicyForm({ policy, canEdit, save }: { policy: Policy; canEdit: boolean;
  save: (input: Policy & { expectedRevision: number; reason: string; confirmation: string }) => Promise<void> }) {
  const [minimum, setMinimum] = useState(String(policy.minimumLiveBuildNumber));
  const [updateUrl, setUpdateUrl] = useState(policy.updateUrl);
  const [reason, setReason] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [busy, setBusy] = useState(false);
  const [notice, setNotice] = useState("");
  return <form className="grant-form" onSubmit={event => {
    event.preventDefault();
    if (busy || !canEdit) return;
    if (!/^\d+$/.test(minimum) || !Number.isSafeInteger(Number(minimum)) || Number(minimum) > 2_100_000_000) { setNotice("Enter a whole build number from 0 to 2100000000."); return; }
    setBusy(true); setNotice("");
    void save({ ...policy, minimumLiveBuildNumber: Number(minimum), updateUrl, expectedRevision: policy.revision, reason, confirmation })
      .then(() => setNotice("Minimum live build saved."))
      .catch(error => setNotice(error instanceof Error ? error.message : "Unable to save."))
      .finally(() => setBusy(false));
  }}>
    <label>Minimum Live Build Number<input type="number" min="0" max="2100000000" step="1" required disabled={!canEdit || busy} value={minimum} onChange={event => setMinimum(event.target.value)} /></label>
    <label>Update URL<input type="url" required disabled={!canEdit || busy} value={updateUrl} onChange={event => setUpdateUrl(event.target.value)} /></label>
    {canEdit ? <>
      <label>Operator reason<input required maxLength={500} disabled={busy} value={reason} onChange={event => setReason(event.target.value)} /></label>
      <label>Type SET MINIMUM LIVE BUILD<input required disabled={busy} value={confirmation} onChange={event => setConfirmation(event.target.value)} /></label>
      <button className="button" disabled={busy || confirmation !== "SET MINIMUM LIVE BUILD" || !reason.trim()} type="submit">{busy ? "Saving…" : "Save minimum build"}</button>
    </> : null}
    {notice ? <InlineNotice>{notice}</InlineNotice> : null}
  </form>;
}
